/** `InputEvent.inputType` values the ui-kit fields react to. */
export const InputEventType = {
  InsertText: 'insertText',
  InsertFromPaste: 'insertFromPaste',
  InsertFromDrop: 'insertFromDrop',
  InsertReplacementText: 'insertReplacementText',
  DeleteContentBackward: 'deleteContentBackward',
  DeleteContentForward: 'deleteContentForward',
  DeleteWordBackward: 'deleteWordBackward',
  DeleteWordForward: 'deleteWordForward',
  DeleteSoftLineBackward: 'deleteSoftLineBackward',
  DeleteByCut: 'deleteByCut',
} as const;
export type InputEventType = (typeof InputEventType)[keyof typeof InputEventType];
